import React, { Component } from 'react';
import Header from '../../Shared/Header';
import Footer from '../../Shared/Footer';
import Footer2 from '../../Shared/Footer2';
import '../../../css/TruckVisits/TruckVisitsTrack.css';
import truckregistration from '../../../Assets/TruckVisits/Assets-Desktop/truck-registration.svg';
import indicatorcompleted from '../../../Assets/ContainerStatus/Assets_Desktop/indicator-completed.svg';
import indicatorincomplete from '../../../Assets/ContainerStatus/Assets_Desktop/indicator-incomplete.svg';
import MetaDecorator from '../../../ReactHelmet/MetaDecorator';
import TitleDescription from '../../../Data/Shared/TitleDescription.json';
import { ApiCall } from '../../../Services/utils/ApiCall';
import { trackingBaseURL } from '../../../Services/config/apiGateway';
import { ALL_TRUCK_DETAILS_ENDPOINT } from '../../../Services/config/apiEndPoints';
// for redux
import { connect } from 'react-redux';


class TruckVisitsTrack extends Component {
    constructor(props) {
        super(props)
        this.state = {
            truckId: '',
            terminalName: '',
            truckDetails: {},
            userType: '',
            inBoundDate: '',
            inBoundTime: '',
            inYardDate: '',
            inYardTime: '',
            outYardDate: '',
            outYardTime: '',
            checkPreGateDate: '',
            checkPreGateTime: '',
            containerLoadedDate: '',
            containerLoadedTime: ''
        }
    }
    getTime = (timeStamp) => {
        if (typeof timeStamp != "undefined") {
            if (timeStamp?.length > 0 && timeStamp != 'N/A' && timeStamp != '') {
                let timeStampNum = parseInt(timeStamp);
                return new Date(timeStampNum).toGMTString().split(' ')[4].substring(0, 5)
            }
        }
        return '';
    }

    getDate = (timeStamp) => {
        if (typeof timeStamp != "undefined") {
            if (timeStamp?.length > 0 && timeStamp != 'N/A' && timeStamp != '') {
                let timeStampNum = parseInt(timeStamp);
                let date = new Date(timeStampNum).toGMTString();
                let day = date.split(' ')[1];
                let month = date.split(' ')[2];
                let year = date.split(' ')[3];
                return `${day}-${month}-${year}`;
            }
        }
        return '';
    }


    componentDidMount() {
        this.setState({ userType: this.props.manageProfileDataR?.tileUserType });
        const { truckNumber, terminalName, createdDate } = this.props.match.params;
        this.setState({ truckId: truckNumber, terminalName: terminalName });
        
        if (!this.props.history.location.state) {
            ApiCall(
                'GET',
                trackingBaseURL + ALL_TRUCK_DETAILS_ENDPOINT + `?truckRegnNbr=${truckNumber}`,
                {},
                {
                    Accept: 'application/json',
                    'Content-Type': 'application/json',


                },
            ).then((apiData) => {

                if (apiData.flag != -1) {
                    if (apiData.flag == 500) {
                        console.log("in 500");
                    }
                    else {
                        console.log('I am 200!');
                        apiData?.find((name) => {
                            if (name?.terminal === terminalName && name?.createdDate === createdDate) {
                                this.setState({
                                    truckDetails: name,
                                    checkPreGateDate: this.getDate(name?.createdDate),
                                    checkPreGateTime: this.getTime(name?.createdDate),
                                    inBoundDate: this.getDate(name?.inboundDate),
                                    inBoundTime: this.getTime(name?.inboundDate),
                                    inYardDate: this.getDate(name?.inYardDate),
                                    inYardTime: this.getTime(name?.inYardDate),
                                    outYardDate: this.getDate(name?.outYardDate),
                                    outYardTime: this.getTime(name?.outYardDate),
                                });
                            }
                        });
                    }
                }
            });
        } else {
            this.setState({
                truckDetails: this.props.history.location.state,
                checkPreGateDate: this.getDate(this.props.history.location.state?.createdDate),
                checkPreGateTime: this.getTime(this.props.history.location.state?.createdDate),
                inBoundDate: this.getDate(this.props.history.location.state?.inboundDate),
                inBoundTime: this.getTime(this.props.history.location.state?.inboundDate),
                inYardDate: this.getDate(this.props.history.location.state?.inYardDate),
                inYardTime: this.getTime(this.props.history.location.state?.inYardDate),
                outYardDate: this.getDate(this.props.history.location.state?.outYardDate),
                outYardTime: this.getTime(this.props.history.location.state?.outYardDate),
            });
        }
    }

    componentWillUnmount() {
        if (this.props.history.action === 'POP' && this.props.history.location.pathname === '/truckVisit') {

            this.props.history.replace({
                pathname: '/truckVisit',
                state: { truckId: this.state.truckId }
            }
            );
        }
    }

    render() {

        return (
            <div class="csoutercolor">
                <MetaDecorator title={TitleDescription.truckVisitsTrackPageTitle} description={TitleDescription.truckVisitsTrackPageDescription} />
                <Header tilesFetched={() => { }} />
                <div class="vcsnofulltrucktr">
                    <div id="vcsnobox1trucktr">
                        <nav class="ccnononavbar">
                            <div className="ccnonavbarname">
                                <small id="nonavc">Truck Visits</small>
                            </div>
                        </nav>
                        <hr class="hr1" />
                        <div class="trucknotificationmaincard">
                            <div class="truckcsdivlow1">
                                <div class="csdivlow2">
                                    <small class="csdivlow2div"><img src={truckregistration} class="mr-3" id="" alt="" loading="lazy" />Truck Registration No.</small>
                                    <small class="pl-3" id="csupdivsmtruchhaed">{this.state.truckId}</small></div>
                            </div>
                            <div class="csdivlow3VisitsTrack">
                                {this.props.manageProfileDataR?.tileUserType == "Premium" ?
                                    <div class="csdivlow4truck4">
                                        <div class="truckconcscardin1" >
                                            <small class="cscardsm1">Terminal</small>
                                            <small class="cscardsm2">{this.state.truckDetails.terminalName}</small>
                                        </div>
                                        <div class="truckconcscardin3" >
                                            <small class="cscardsm1">Status</small>
                                            <small class="cscardsm2">{this.state.truckDetails.status}</small>
                                        </div>
                                    </div>
                                    :
                                    <div class="csdivlow4truck4">
                                        <div class="truckconcscardin1" >
                                            <small class="cscardsm1">Terminal</small>
                                            <small class="cscardsm2">{this.state.truckDetails.terminalName}</small>
                                        </div>
                                    </div>
                                }
                                {/* Premium Card */}
                                {this.props.manageProfileDataR?.tileUserType == "Premium" ?
                                    <div class="truckcsdivlow5">
                                        <div class="cscardtwoin11">
                                            <div class="cscardtwoin2">
                                                <div class="csrowdiv">
                                                    <div id="cslastdiv1TruckfirstVisitsTrack"></div>
                                                    <div class="truckcslastdiv1Truck1">
                                                        <div class="" id="truckmarginbot"><small id="cscardtwoinsm1truck2">
                                                            <img src={(this.state.checkPreGateDate !== "" && this.state.checkPreGateTime !== "") ? indicatorcompleted : indicatorincomplete} id="truckindecatorcompletedimg" class="mb-1" alt="" loading="lazy" />A check / Pre-gate</small></div>

                                                        <div class="truckmarginbotout" id="cscardtwoin3">
                                                            <div class="mb-1" id="cscardtwoin4">
                                                                <small class="cscardtwoinsm2">Date & Time</small>
                                                                <div class="truckcscardtwoinsm3"><small id="cscardtwoinsm33">{this.state.checkPreGateDate}</small><small id="cscardtwoinsm33" class="ml-2">{this.state.checkPreGateTime}</small></div>
                                                            </div>
                                                        </div>
                                                    </div>
                                                </div>
                                                <div class="csrowdiv">
                                                    <div id="cslastdiv1Truck"></div>
                                                    <div class="truckcslastdiv1Truck1">
                                                        <div class="" id="truckmarginbot"><small id="cscardtwoinsm1truck2">
                                                            <img src={(this.state.inBoundDate !== '' && this.state.inBoundTime !== '') ? indicatorcompleted : indicatorincomplete} id="truckindecatorcompletedimg" class="mb-1" alt="" loading="lazy" />
                                                                    Inbound</small></div>
                                                        <div class="truckmarginbotout" id="cscardtwoin3">
                                                            <div class="mb-1" id="cscardtwoin4">
                                                                <small class="cscardtwoinsm2">Date & Time</small>
                                                                <div class="truckcscardtwoinsm3"><small id="cscardtwoinsm33">{this.state.inBoundDate}</small><small id="cscardtwoinsm33" class="ml-2">{this.state.inBoundTime}</small></div>
                                                            </div>
                                                        </div>

                                                    </div>
                                                </div>
                                                <div class="csrowdiv">
                                                    <div id="cslastdiv1Truck"></div>
                                                    <div class="truckcslastdiv1Truck1">
                                                        <div class="" id="truckmarginbot"><small id="cscardtwoinsm1truck2">
                                                            <img src={(this.state.containerLoadedDate !== "" || this.state.truckDetails.containerNumber !== '' || this.state.containerLoadedTime !== '') ? indicatorcompleted : indicatorincomplete} id="truckindecatorcompletedimg" class="mb-1" alt="" loading="lazy" />
                                                                    Container Handled</small></div>
                                                        <div class="truckmarginbotout" id="cscardtwoin3">
                                                            <div class="mb-1" id="cscardtwoin4">
                                                                <small class="cscardtwoinsm2">Container No.</small>
                                                                <small class="truckcscardtwoinsm3">{this.state.truckDetails.containerNumber}</small>
                                                            </div>
                                                            <div class="mb-1" id="cscardtwoin4">
                                                                <small class="cscardtwoinsm2">Date & Time</small>
                                                                <div class="truckcscardtwoinsm3"><small id="cscardtwoinsm33">{this.state.containerLoadedDateTime}</small><small id="cscardtwoinsm33" class="ml-2">{this.state.containerLoadedTime}</small></div>
                                                            </div>
                                                        </div>
                                                    </div>
                                                </div>
                                                <div class="csrowdiv">
                                                    <div></div>
                                                    <div class="truckcslastdiv1Truck1">
                                                        <div class="" id="truckmarginbot"><small id="cscardtwoinsm1truck2">
                                                            <img src={(this.state.OutYardDate !== '' && this.state.outYardTime !== '') ? indicatorcompleted : indicatorincomplete} id="truckindecatorcompletedimg" class="mb-1" alt="" loading="lazy" />
                                                                    Out Yard</small></div>
                                                        <div class="truckmarginbotout" id="cscardtwoin3">
                                                            <div class="mb-1" id="cscardtwoin4">
                                                                <small class="cscardtwoinsm2">Date & Time</small>
                                                                <div class="truckcscardtwoinsm3"><small id="cscardtwoinsm33">{this.state.outYardDate}</small><small id="cscardtwoinsm33" class="ml-2">{this.state.outYardTime}</small></div>
                                                            </div>
                                                        </div>
                                                    </div>
                                                </div>
                                            </div>
                                        </div>
                                    </div>
                                    :
                                    <div class="truckcsdivlow5">
                                        <div class="cscardtwoin11">
                                            <div class="cscardtwoin2">
                                                <div class="csrowdiv">
                                                    <div id="cslastdiv1TruckfirstVisitsTrack"></div>
                                                    <div class="truckcslastdiv1Truck1">
                                                        <div class="" id="truckmarginbot"><small id="cscardtwoinsm1truck2">
                                                            <img src={(this.state.checkPreGateDate !== "" && this.state.checkPreGateTime !== "") ? indicatorcompleted : indicatorincomplete} id="truckindecatorcompletedimg" class="mb-1" alt="" loading="lazy" />
                                                            A check / Pre-gate</small></div>
                                                        <div class="truckmarginbotout" id="cscardtwoin3">
                                                            <div class="mb-1" id="cscardtwoin4">
                                                                <small class="cscardtwoinsm2">Date & Time</small>
                                                                <div class="truckcscardtwoinsm3"><small id="cscardtwoinsm33">{this.state.checkPreGateDate}</small><small id="cscardtwoinsm33" class="ml-2">{this.state.checkPreGateTime}</small></div>
                                                            </div>
                                                        </div>
                                                    </div>
                                                </div>
                                                <div class="csrowdiv">
                                                    <div id="cslastdiv1Truck"></div>
                                                    <div class="truckcslastdiv1Truck1">
                                                        <div class="" id="truckmarginbot"><small id="cscardtwoinsm1truck2">
                                                            <img src={(this.state.inBoundDate !== "" && this.state.inBoundTime !== '') ? indicatorcompleted : indicatorincomplete} id="truckindecatorcompletedimg" class="mb-1" alt="" loading="lazy" />
                                                                    Inbound</small></div>
                                                        <div class="truckmarginbotout" id="cscardtwoin3">
                                                            <div class="mb-1" id="cscardtwoin4">
                                                                <small class="cscardtwoinsm2">Date & Time</small>
                                                                <div class="truckcscardtwoinsm3"><small id="cscardtwoinsm33">{this.state.inBoundDate}</small><small id="cscardtwoinsm33" class="ml-2">{this.state.inBoundTime}</small></div>
                                                            </div>
                                                        </div>
                                                    </div>
                                                </div>
                                                <div class="csrowdiv">
                                                    <div></div>
                                                    <div class="truckcslastdiv1Truck1">
                                                        <div class="" id="truckmarginbot"><small id="cscardtwoinsm1truck2">
                                                            <img src={(this.state.outYardDate !== "" && this.state.outYardTime !== '') ? indicatorcompleted : indicatorincomplete} id="truckindecatorcompletedimg" class="mb-1" alt="" loading="lazy" />
                                                                    Out Yard</small></div>
                                                        <div class="truckmarginbotout" id="cscardtwoin3">
                                                            <div class="mb-1" id="cscardtwoin4">
                                                                <small class="cscardtwoinsm2">Date & Time</small>
                                                                <div class="truckcscardtwoinsm3"><small id="cscardtwoinsm33">{this.state.outYardDate}</small><small id="cscardtwoinsm33" class="ml-2">{this.state.outYardTime}</small></div>
                                                            </div>
                                                        </div>
                                                    </div>
                                                </div>
                                            </div>
                                        </div>
                                    </div>
                                }
                            </div>
                            <div>
                            </div>
                        </div>
                    </div>
                </div>
                <div class="vnotifooter01">
                    <Footer />
                </div>
                <div class="vnotifooter02">
                    <Footer2 />
                </div>
            </div>
        );
    }
}

function mapStateToProps(state) {
    return {
        manageProfileDataR: state.manageProfileReducer.data
    }
}

export default connect(mapStateToProps)(TruckVisitsTrack);